// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-fetch';
import type { ResignMemberUsingDelete1Data, ResignMemberUsingDelete1Response, CreateApiCounselUsingPostData, CreateApiCounselUsingPostResponse, GetApiPolicyListUsingGetData, GetApiPolicyListUsingGetResponse, GetApiPolicyNameListUsingGetData, GetApiPolicyNameListUsingGetResponse, GetApiProductNameListUsingGetData, GetApiProductNameListUsingGetResponse, GetApiThemeListUsingGetData, GetApiThemeListUsingGetResponse, GetApiThemeNameListUsingGetData, GetApiThemeNameListUsingGetResponse, GetApiThemeUsingGetData, GetApiThemeUsingGetResponse, GetApiThemeKeywordNameListUsingGetData, GetApiThemeKeywordNameListUsingGetResponse, AvailCardListUsingGetData, AvailCardListUsingGetResponse, BankListUsingGetData, BankListUsingGetResponse, BannerListUsingGetData, BannerListUsingGetResponse, BestContentsListUsingGet1Data, BestContentsListUsingGet1Response, BestContentsFeedbackUsingGet1Data, BestContentsFeedbackUsingGet1Response, GetNewBestContentsListUsingGet1Data, GetNewBestContentsListUsingGet1Response, GetPopularBestContentsListUsingGet1Data, GetPopularBestContentsListUsingGet1Response, GetBestContentsUsingGetData, GetBestContentsUsingGetResponse, CommonCodeInitUsingPostData, CommonCodeInitUsingPostResponse, CardListUsingGetData, CardListUsingGetResponse, GetListChildcarePolicyBudgetUsingGetData, GetListChildcarePolicyBudgetUsingGetResponse, GetListChildcareRelatedPolicyUsingGet1Data, GetListChildcareRelatedPolicyUsingGet1Response, CommonCodeInitUsingPost1Data, CommonCodeInitUsingPost1Response, GetCommunityBannerListUsingGetData, GetCommunityBannerListUsingGetResponse, GetLatestCommunityListUsingGet1Data, GetLatestCommunityListUsingGet1Response, GetCommunityMainCategoryListUsingGetData, GetCommunityMainCategoryListUsingGetResponse, GetCommunitySubcategoryListByCodeUsingGetData, GetCommunitySubcategoryListByCodeUsingGetResponse, GetCommunityVoucherCategoryUsingGetData, GetCommunityVoucherCategoryUsingGetResponse, GetRecommendCommunityVoucherCategoryUsingGetData, GetRecommendCommunityVoucherCategoryUsingGetResponse, GetCommunityVoucherCategoryShuffleListUsingGetData, GetCommunityVoucherCategoryShuffleListUsingGetResponse, GetCommunityCategoryUsingGetData, GetCommunityCategoryUsingGetResponse, GetCommunityVoucherCategoryPolicyListUsingGet1Data, GetCommunityVoucherCategoryPolicyListUsingGet1Response, GetCommunityFreeTalkListUsingGet1Data, GetCommunityFreeTalkListUsingGet1Response, FeedbackCommunityFreeTalkUsingGet1Data, FeedbackCommunityFreeTalkUsingGet1Response, GetCommunityFreeTalkHotListUsingGet1Data, GetCommunityFreeTalkHotListUsingGet1Response, GetPopularCommunityFreeTalkListUsingGet1Data, GetPopularCommunityFreeTalkListUsingGet1Response, GetCommunityFreeTalkUsingGet1Data, GetCommunityFreeTalkUsingGet1Response, GetCommunityParticipantListUsingGetData, GetCommunityParticipantListUsingGetResponse, GetCommunityPolicyTalkListUsingGet1Data, GetCommunityPolicyTalkListUsingGet1Response, FeedbackCommunityPolicyTalkUsingGet1Data, FeedbackCommunityPolicyTalkUsingGet1Response, GetHomePolicyReviewListUsingGetData, GetHomePolicyReviewListUsingGetResponse, GetCommunityPolicyTalkHotListUsingGet1Data, GetCommunityPolicyTalkHotListUsingGet1Response, GetCommunityPolicyTalkPolicyApplyListUsingGet1Data, GetCommunityPolicyTalkPolicyApplyListUsingGet1Response, GetPopularCommunityPolicyTalkListUsingGet1Data, GetPopularCommunityPolicyTalkListUsingGet1Response, GetCommunityPolicyTalkUsingGet1Data, GetCommunityPolicyTalkUsingGet1Response, GetCommunityVoucherListUsingGetData, GetCommunityVoucherListUsingGetResponse, FeedbackCommunityVoucherUsingGet1Data, FeedbackCommunityVoucherUsingGet1Response, GetSampleCommunityVoucherUsingGetData, GetSampleCommunityVoucherUsingGetResponse, GetCommunityVoucherUsingGetData, GetCommunityVoucherUsingGetResponse, GetRelatedCommunityVoucherListUsingGetData, GetRelatedCommunityVoucherListUsingGetResponse, GetCommunityWelloNewsListUsingGet1Data, GetCommunityWelloNewsListUsingGet1Response, FeedbackCommunityWelloNewsUsingGet1Data, FeedbackCommunityWelloNewsUsingGet1Response, GetCommunityWelloNewsUsingGet1Data, GetCommunityWelloNewsUsingGet1Response, GetEVoucherAgencyListUsingGetData, GetEVoucherAgencyListUsingGetResponse, GetVoucherBannerListUsingGetData, GetVoucherBannerListUsingGetResponse, GetEVoucherCardListUsingGetData, GetEVoucherCardListUsingGetResponse, GetVoucherCategoryListUsingGetData, GetVoucherCategoryListUsingGetResponse, GetVoucherOnlineCategoryListUsingGetData, GetVoucherOnlineCategoryListUsingGetResponse, GetVoucherCategoryPolicyListUsingGetData, GetVoucherCategoryPolicyListUsingGetResponse, GetVoucherOnlineListUsingGetData, GetVoucherOnlineListUsingGetResponse, GetEVoucherProviderListUsingGet1Data, GetEVoucherProviderListUsingGet1Response, GetEVoucherProviderListAllUsingGet1Data, GetEVoucherProviderListAllUsingGet1Response, GetEVoucherProviderCardListUsingGetData, GetEVoucherProviderCardListUsingGetResponse, GetEVoucherProviderFeedbackUsingGet1Data, GetEVoucherProviderFeedbackUsingGet1Response, GetEVoucherProviderRegionListUsingGetData, GetEVoucherProviderRegionListUsingGetResponse, GetEVoucherProviderUsingGet1Data, GetEVoucherProviderUsingGet1Response, GetEmergencyRoomListUsingGet1Data, GetEmergencyRoomListUsingGet1Response, GetEmergencyRoomCodeListUsingGetData, GetEmergencyRoomCodeListUsingGetResponse, GetEmergencyRoomListCountUsingGetData, GetEmergencyRoomListCountUsingGetResponse, GetEmergencyRoomRegionListUsingGetData, GetEmergencyRoomRegionListUsingGetResponse, GetEmergencyRoomUsingGet1Data, GetEmergencyRoomUsingGet1Response, GetEmergencyRoomLiveUsingGetData, GetEmergencyRoomLiveUsingGetResponse, ExpositionLinkUrlListUsingGetData, ExpositionLinkUrlListUsingGetResponse, FaqListUsingGetData, FaqListUsingGetResponse, GetNCloudGeocodingByCodeUsingGetData, GetNCloudGeocodingByCodeUsingGetResponse, HometownNewsListUsingGet1Data, HometownNewsListUsingGet1Response, HometownNewsFeedbackUsingGet1Data, HometownNewsFeedbackUsingGet1Response, GetPopularHometownNewsListUsingGet1Data, GetPopularHometownNewsListUsingGet1Response, GetPopularHometownNewsListForCommunityUsingGet1Data, GetPopularHometownNewsListForCommunityUsingGet1Response, HometownNewsUsingGet1Data, HometownNewsUsingGet1Response, GetRelatedHometownNewsListUsingGetData, GetRelatedHometownNewsListUsingGetResponse, JoinEventUsingPostData, JoinEventUsingPostResponse, LoginWelloWithKbPayUsingPostData, LoginWelloWithKbPayUsingPostResponse, SaveLoginResultUsingPostData, SaveLoginResultUsingPostResponse, TermHistoryUsingGetData, TermHistoryUsingGetResponse, GetEVoucherProviderListUsingGet2Data, GetEVoucherProviderListUsingGet2Response, AdminRefreshTokenUsingGetData, AdminRefreshTokenUsingGetResponse, WelloBeforeLoginUsingPostData, WelloBeforeLoginUsingPostResponse, GetKbMemberLoginTypeListUsingGetData, GetKbMemberLoginTypeListUsingGetResponse, LoginWelloSnsMemberUsingPostData, LoginWelloSnsMemberUsingPostResponse, SnsRefreshTokenUsingGetData, SnsRefreshTokenUsingGetResponse, TokenStatusCheckUsingPostData, TokenStatusCheckUsingPostResponse, CheckPlusSuccessUsingGetData, CheckPlusSuccessUsingGetResponse, NoticeListUsingGetData, NoticeListUsingGetResponse, RejectMessageUsingPut1Data, RejectMessageUsingPut1Response, MetaCodeAllUsingGetData, MetaCodeAllUsingGetResponse, CommonCodeInitUsingPost2Data, CommonCodeInitUsingPost2Response, AllowsInterestPolicyListUsingGetData, AllowsInterestPolicyListUsingGetResponse, MetaPolicyListUsingGet1Data, MetaPolicyListUsingGet1Response, MetaPolicyCountUsingGetData, MetaPolicyCountUsingGetResponse, MetaPolicyFeedbackUsingGet1Data, MetaPolicyFeedbackUsingGet1Response, LatestMetaPolicyListUsingGetData, LatestMetaPolicyListUsingGetResponse, GetLatestPolicyListUsingGetData, GetLatestPolicyListUsingGetResponse, GetPolicyListByPolicyNameUsingGetData, GetPolicyListByPolicyNameUsingGetResponse, PopularPolicyListUsingGetData, PopularPolicyListUsingGetResponse, MetaPolicyTop10ListUsingGetData, MetaPolicyTop10ListUsingGetResponse, MetaPolicyUsingGet1Data, MetaPolicyUsingGet1Response, UpdatePolicyAiInfoUsingPutData, UpdatePolicyAiInfoUsingPutResponse, GetRelatedMetaPolicyListUsingGet1Data, GetRelatedMetaPolicyListUsingGet1Response, GetPolicyRelatedCommunityListUsingGetData, GetPolicyRelatedCommunityListUsingGetResponse, NoticeListUsingGet1Data, NoticeListUsingGet1Response, NoticeUsingGetData, NoticeUsingGetResponse, GetPointBudgetUsingGet1Data, GetPointBudgetUsingGet1Response, GetPointEarningUsingGetData, GetPointEarningUsingGetResponse, GetPointInfoUsingGetData, GetPointInfoUsingGetResponse, GetListPolicyCaseCategoryUsingGetData, GetListPolicyCaseCategoryUsingGetResponse, GetPolicyCodeGeocodingListUsingGetData, GetPolicyCodeGeocodingListUsingGetResponse, GetPolicyDictionaryListUsingGetData, GetPolicyDictionaryListUsingGetResponse, GetRandomTicketWinnerListUsingGetData, GetRandomTicketWinnerListUsingGetResponse, FileDeleteUsingDelete1Data, FileDeleteUsingDelete1Response, FileUploadUsingPost2Data, FileUploadUsingPost2Response, UpdateFileTempSaveYnUsingPut1Data, UpdateFileTempSaveYnUsingPut1Response, FileDecryptionDownloadUsingGet1Data, FileDecryptionDownloadUsingGet1Response, SituationListUsingGet1Data, SituationListUsingGet1Response, GetSituationPolicyListUsingGet1Data, GetSituationPolicyListUsingGet1Response, TermUsingGetData, TermUsingGetResponse, GetWelcomeMonitorDisplayListUsingGetData, GetWelcomeMonitorDisplayListUsingGetResponse, WelloAppPushListUsingGetData, WelloAppPushListUsingGetResponse, UpdateWelloAppPushReadUsingPut1Data, UpdateWelloAppPushReadUsingPut1Response, NewWelloAppPushCntUsingGetData, NewWelloAppPushCntUsingGetResponse, SendExtAppPushUsingPostData, SendExtAppPushUsingPostResponse, UpdateWelloAppPushReadUsingPostData, UpdateWelloAppPushReadUsingPostResponse, GetMetaPolicyCommentListUsingGet2Data, GetMetaPolicyCommentListUsingGet2Response, GetCommunityVoucherCommentListUsingGetData, GetCommunityVoucherCommentListUsingGetResponse, GetLiveWelloCommentListUsingGet1Data, GetLiveWelloCommentListUsingGet1Response, GetMetaPolicyCommentListUsingGet1Data, GetMetaPolicyCommentListUsingGet1Response, SaveAllowsWelloDeviceInfoUsingPostData, SaveAllowsWelloDeviceInfoUsingPostResponse, MessageReceiveUsingGetData, MessageReceiveUsingGetResponse, UpdateMessageReceiveUsingPutData, UpdateMessageReceiveUsingPutResponse, DetailWelloLandingUsingGetData, DetailWelloLandingUsingGetResponse, SendCertificationCellphoneUsingPost1Data, SendCertificationCellphoneUsingPost1Response, CertificationCheckUsingPost1Data, CertificationCheckUsingPost1Response, SaveWelloNonmemberRegionUsingPostData, SaveWelloNonmemberRegionUsingPostResponse, WelloPickListUsingGet1Data, WelloPickListUsingGet1Response, WelloPickPolicyListUsingGet1Data, WelloPickPolicyListUsingGet1Response, GetWelloPickBannerListUsingGetData, GetWelloPickBannerListUsingGetResponse, GetHomeWelloPolicyApplyListUsingGetData, GetHomeWelloPolicyApplyListUsingGetResponse, WelloPolicyCodeListUsingGetData, WelloPolicyCodeListUsingGetResponse, WelloPolicyCodeAllListUsingGetData, WelloPolicyCodeAllListUsingGetResponse, WelloPolicyCodeBabyListUsingGetData, WelloPolicyCodeBabyListUsingGetResponse, GeolocationUsingGetData, GeolocationUsingGetResponse, KbWelloPolicyCodeAllListUsingGetData, KbWelloPolicyCodeAllListUsingGetResponse, ReverseGeocodingUsingGetData, ReverseGeocodingUsingGetResponse, MetaPolicyWishlistUsingGet1Data, MetaPolicyWishlistUsingGet1Response, MetaPolicyWishlistUsingGet2Data, MetaPolicyWishlistUsingGet2Response, SaveWelloTrackingUsingPost1Data, SaveWelloTrackingUsingPost1Response } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 회원 탈퇴(관리자용)
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHmember = <ThrowOnError extends boolean = false>(options?: Options<ResignMemberUsingDelete1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<ResignMemberUsingDelete1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * API 도입 문의 작성
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounsel = <ThrowOnError extends boolean = false>(options?: Options<CreateApiCounselUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateApiCounselUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/api-counsel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * API 개별 상품 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicy = <ThrowOnError extends boolean = false>(options: Options<GetApiPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPolicyListUsingGetResponse, unknown, ThrowOnError>({
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/allows/api-policy',
        ...options
    });
};

/**
 * API 개별 상품명 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHname = <ThrowOnError extends boolean = false>(options: Options<GetApiPolicyNameListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiPolicyNameListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/api-policy/name',
        ...options
    });
};

/**
 * API 상품명 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHproductSLASHname = <ThrowOnError extends boolean = false>(options: Options<GetApiProductNameListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiProductNameListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/api-product/name',
        ...options
    });
};

/**
 * API 패키지 상품 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHtheme = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiThemeListUsingGetResponse, unknown, ThrowOnError>({
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/allows/api-theme',
        ...options
    });
};

/**
 * API 패키지명 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHname = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeNameListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiThemeNameListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/api-theme/name',
        ...options
    });
};

/**
 * API 패키지 상품 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHLBRACEapiUNDERSCOREthemeUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiThemeUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/api-theme/{api_theme_id}',
        ...options
    });
};

/**
 * API 패키지명 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHname = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeKeywordNameListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiThemeKeywordNameListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/api-theme/keyword/name',
        ...options
    });
};

/**
 * 신청카드 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHavailDASHcard = <ThrowOnError extends boolean = false>(options: Options<AvailCardListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AvailCardListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/avail-card',
        ...options
    });
};

/**
 * 은행 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbank = <ThrowOnError extends boolean = false>(options?: Options<BankListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<BankListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/bank',
        ...options
    });
};

/**
 * 배너 목록 조회
 * 배너 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbanner = <ThrowOnError extends boolean = false>(options: Options<BannerListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BannerListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/banner',
        ...options
    });
};

/**
 * 정책 소식 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbest = <ThrowOnError extends boolean = false>(options: Options<BestContentsListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BestContentsListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/best',
        ...options
    });
};

/**
 * 정책 소식 내 고잭정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<BestContentsFeedbackUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BestContentsFeedbackUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/best/feedback/{best_contents_id}',
        ...options
    });
};

/**
 * 신규 정책 소식 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHnew = <ThrowOnError extends boolean = false>(options?: Options<GetNewBestContentsListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNewBestContentsListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/best/new',
        ...options
    });
};

/**
 * 인기 정책 소식 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularBestContentsListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularBestContentsListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/best/popular',
        ...options
    });
};

/**
 * 정책 소식 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetBestContentsUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBestContentsUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/best/{best_contents_id_idx}',
        ...options
    });
};

/**
 * 블록리스트 초기화
 * 블록리스트 추가된 경우 초기화 합니다
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHreset = <ThrowOnError extends boolean = false>(options: Options<CommonCodeInitUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommonCodeInitUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/blocklist/reset',
        ...options
    });
};

/**
 * 카드사 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcard = <ThrowOnError extends boolean = false>(options: Options<CardListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CardListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/card',
        ...options
    });
};

/**
 * 내 상황에 맞는 육아 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbaby = <ThrowOnError extends boolean = false>(options: Options<GetListChildcarePolicyBudgetUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetListChildcarePolicyBudgetUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy-case/baby',
        ...options
    });
};

/**
 * 내 상황에 맞는 육아 정책 관련 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicy = <ThrowOnError extends boolean = false>(options: Options<GetListChildcareRelatedPolicyUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetListChildcareRelatedPolicyUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy-case/baby/related-policy',
        ...options
    });
};

/**
 * 공통코드 초기화
 * 공통코드가 추가된 경우 초기화 합니다
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHreset = <ThrowOnError extends boolean = false>(options: Options<CommonCodeInitUsingPost1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommonCodeInitUsingPost1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/common/meta-code/reset',
        ...options
    });
};

/**
 * 커뮤니티 롤링 배너
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHbanner = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityBannerListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityBannerListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/banner',
        ...options
    });
};

/**
 * 커뮤니티 최신글
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHlatest = <ThrowOnError extends boolean = false>(options?: Options<GetLatestCommunityListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLatestCommunityListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/latest',
        ...options
    });
};

/**
 * 커뮤니티 카테고리 - 메인 카테고리 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHmainDASHcategory = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityMainCategoryListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityMainCategoryListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/category/main-category',
        ...options
    });
};

/**
 * 커뮤니티 카테고리 - 서브 카테고리 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHsubcategory = <ThrowOnError extends boolean = false>(options: Options<GetCommunitySubcategoryListByCodeUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunitySubcategoryListByCodeUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/category/subcategory',
        ...options
    });
};

/**
 * 커뮤니티 - 질문 유도 배너 카테고리 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHbanner = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityVoucherCategoryUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityVoucherCategoryUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/category/voucher-banner',
        ...options
    });
};

/**
 * 커뮤니티 - 추천 바우처 카테고리 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHrecommend = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendCommunityVoucherCategoryUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRecommendCommunityVoucherCategoryUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/category/voucher-recommend',
        ...options
    });
};

/**
 * 커뮤니티 - 등록 된 바우처 커뮤니티 목록 조회(랜덤)
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHshuffle = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityVoucherCategoryShuffleListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityVoucherCategoryShuffleListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/category/voucher-shuffle',
        ...options
    });
};

/**
 * 커뮤니티 카테고리 - 하위 카테고리 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHchild = <ThrowOnError extends boolean = false>(options: Options<GetCommunityCategoryUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityCategoryUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/category/{community_category_id}/child',
        ...options
    });
};

/**
 * 커뮤니티 - 카테고리에 해당되는 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicy = <ThrowOnError extends boolean = false>(options: Options<GetCommunityVoucherCategoryPolicyListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityVoucherCategoryPolicyListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/category/{community_category_id}/policy',
        ...options
    });
};

/**
 * 커뮤니티 - 자유 수다 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalk = <ThrowOnError extends boolean = false>(options: Options<GetCommunityFreeTalkListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityFreeTalkListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/free-talk',
        ...options
    });
};

/**
 * 커뮤니티 - 자유 수다 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityFreeTalkUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityFreeTalkUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/free-talk/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - HOT한 수다 - 자유수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhot = <ThrowOnError extends boolean = false>(options: Options<GetCommunityFreeTalkHotListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityFreeTalkHotListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/free-talk/hot',
        ...options
    });
};

/**
 * 커뮤니티 - 인기 자유수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularCommunityFreeTalkListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularCommunityFreeTalkListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/free-talk/popular',
        ...options
    });
};

/**
 * 커뮤니티 - 자유 수다 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetCommunityFreeTalkUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityFreeTalkUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/free-talk/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 참여자 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipant = <ThrowOnError extends boolean = false>(options: Options<GetCommunityParticipantListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityParticipantListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/participant',
        ...options
    });
};

/**
 * 커뮤니티 - 정책 수다 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalk = <ThrowOnError extends boolean = false>(options: Options<GetCommunityPolicyTalkListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityPolicyTalkListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/policy-talk',
        ...options
    });
};

/**
 * 커뮤니티 - 정책 수다 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityPolicyTalkUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityPolicyTalkUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/policy-talk/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 홈화면 - 정책 후기 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhomeSLASHpolicyDASHreviews = <ThrowOnError extends boolean = false>(options?: Options<GetHomePolicyReviewListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetHomePolicyReviewListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/policy-talk/home/policy-reviews',
        ...options
    });
};

/**
 * 커뮤니티 - HOT한 수다 - 정책수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhot = <ThrowOnError extends boolean = false>(options: Options<GetCommunityPolicyTalkHotListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityPolicyTalkHotListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/policy-talk/hot',
        ...options
    });
};

/**
 * 커뮤니티 - 정책수다 간편신청 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapply = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityPolicyTalkPolicyApplyListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCommunityPolicyTalkPolicyApplyListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/policy-talk/policy-apply',
        ...options
    });
};

/**
 * 커뮤니티 - 인기 정책수다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularCommunityPolicyTalkListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularCommunityPolicyTalkListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/policy-talk/popular',
        ...options
    });
};

/**
 * 커뮤니티 - 정책 수다 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetCommunityPolicyTalkUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityPolicyTalkUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/policy-talk/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 바우처 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucher = <ThrowOnError extends boolean = false>(options: Options<GetCommunityVoucherListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityVoucherListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/voucher',
        ...options
    });
};

/**
 * 커뮤니티 - 바우처 피드백
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityVoucherUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityVoucherUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/voucher/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 샘플 질문/답변 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHsample = <ThrowOnError extends boolean = false>(options?: Options<GetSampleCommunityVoucherUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSampleCommunityVoucherUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/voucher/sample',
        ...options
    });
};

/**
 * 커뮤니티 - 바우처 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetCommunityVoucherUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityVoucherUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/voucher/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 바우처 다른 질문 보기
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated = <ThrowOnError extends boolean = false>(options: Options<GetRelatedCommunityVoucherListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRelatedCommunityVoucherListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/voucher/{community_id_idx}/related',
        ...options
    });
};

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnews = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityWelloNewsListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/wello-news',
        ...options
    });
};

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityWelloNewsUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeedbackCommunityWelloNewsUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/wello-news/feedback/{community_id_idx}',
        ...options
    });
};

/**
 * 커뮤니티 - 웰로 소식 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityWelloNewsUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/community/wello-news/{community_id_idx}',
        ...options
    });
};

/**
 * 바우처 기관 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHagency = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherAgencyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherAgencyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/agency',
        ...options
    });
};

/**
 * 배너 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHbanner = <ThrowOnError extends boolean = false>(options?: Options<GetVoucherBannerListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetVoucherBannerListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/banner',
        ...options
    });
};

/**
 * 카드사 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcard = <ThrowOnError extends boolean = false>(options?: Options<GetEVoucherCardListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEVoucherCardListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/card',
        ...options
    });
};

/**
 * 카테고리 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategory = <ThrowOnError extends boolean = false>(options?: Options<GetVoucherCategoryListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetVoucherCategoryListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/category',
        ...options
    });
};

/**
 * 온라인 판매처 카테고리 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHonline = <ThrowOnError extends boolean = false>(options?: Options<GetVoucherOnlineCategoryListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetVoucherOnlineCategoryListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/category/online',
        ...options
    });
};

/**
 * 카테고리 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicy = <ThrowOnError extends boolean = false>(options: Options<GetVoucherCategoryPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVoucherCategoryPolicyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/category/{category_id}/policy',
        ...options
    });
};

/**
 * 온라인 판매처 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHonline = <ThrowOnError extends boolean = false>(options: Options<GetVoucherOnlineListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVoucherOnlineListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/online',
        ...options
    });
};

/**
 * 위경도 기반 제공기관 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHprovider = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/provider',
        ...options
    });
};

/**
 * 위경도 기반 제공기관 전체 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHall = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderListAllUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderListAllUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/provider/all',
        ...options
    });
};

/**
 * 바우처 제공처 지원 카드 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHcard = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderCardListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderCardListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/provider/card',
        ...options
    });
};

/**
 * 제공기관 피드백 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderFeedbackUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderFeedbackUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/provider/feedback/{id}',
        ...options
    });
};

/**
 * 위경도 기반 제공기관 지역별 갯수 검색
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHregion = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderRegionListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderRegionListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/provider/region',
        ...options
    });
};

/**
 * 제공기관 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetEVoucherProviderUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEVoucherProviderUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/voucher/provider/{provider_uuid}',
        ...options
    });
};

/**
 * 응급실 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroom = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEmergencyRoomListUsingGet1Response, unknown, ThrowOnError>({
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/allows/emergency-room',
        ...options
    });
};

/**
 * 응급실 관련 코드 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcode = <ThrowOnError extends boolean = false>(options?: Options<GetEmergencyRoomCodeListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEmergencyRoomCodeListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/emergency-room/code',
        ...options
    });
};

/**
 * 응급실 목록 전체 개수 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcount = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListCountUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEmergencyRoomListCountUsingGetResponse, unknown, ThrowOnError>({
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/allows/emergency-room/count',
        ...options
    });
};

/**
 * 응급실 지역별 갯수 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHregion = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomRegionListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEmergencyRoomRegionListUsingGetResponse, unknown, ThrowOnError>({
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/allows/emergency-room/region',
        ...options
    });
};

/**
 * 응급실 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEmergencyRoomUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/emergency-room/{emergencyRoomId}',
        ...options
    });
};

/**
 * 응급실 실시간 데이터 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACESLASHlive = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomLiveUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEmergencyRoomLiveUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/emergency-room/{emergencyRoomId}/live',
        ...options
    });
};

/**
 * 정부박람회 링크 url 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHexpositionDASHlinkDASHurl = <ThrowOnError extends boolean = false>(options?: Options<ExpositionLinkUrlListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExpositionLinkUrlListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/exposition-link-url',
        ...options
    });
};

/**
 * FAQ 목록 조회
 * FAQ 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHfaq = <ThrowOnError extends boolean = false>(options?: Options<FaqListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FaqListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/cs/faq',
        ...options
    });
};

/**
 * 시군구 코드로 위/경도 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHgeocoding = <ThrowOnError extends boolean = false>(options: Options<GetNCloudGeocodingByCodeUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNCloudGeocodingByCodeUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/geocoding',
        ...options
    });
};

/**
 * 동네 소식 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnews = <ThrowOnError extends boolean = false>(options: Options<HometownNewsListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<HometownNewsListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/hometown-news',
        ...options
    });
};

/**
 * 비로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<HometownNewsFeedbackUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<HometownNewsFeedbackUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/hometown-news/feedback/{hometown_news_id}',
        ...options
    });
};

/**
 * 인기 동네 소식 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<GetPopularHometownNewsListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularHometownNewsListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/hometown-news/popular',
        ...options
    });
};

/**
 * 커뮤니티 인기 동네 소식 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularSLASHcommunity = <ThrowOnError extends boolean = false>(options?: Options<GetPopularHometownNewsListForCommunityUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPopularHometownNewsListForCommunityUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/hometown-news/popular/community',
        ...options
    });
};

/**
 * 동네 소식 상세
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<HometownNewsUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<HometownNewsUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/hometown-news/{hometown_news_id_idx}',
        ...options
    });
};

/**
 * 관련 동네소식 목록 조회(최대 10개)
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated = <ThrowOnError extends boolean = false>(options: Options<GetRelatedHometownNewsListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRelatedHometownNewsListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/hometown-news/{hometown_news_id_idx}/related',
        ...options
    });
};

/**
 * 이벤트 참여 요청
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkb = <ThrowOnError extends boolean = false>(options?: Options<JoinEventUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<JoinEventUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/kb',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * KB PAY 회원 웰로 로그인
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHlogin = <ThrowOnError extends boolean = false>(options?: Options<LoginWelloWithKbPayUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LoginWelloWithKbPayUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/kb-pay/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 앱 로그인 요청결과 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHlogin = <ThrowOnError extends boolean = false>(options?: Options<SaveLoginResultUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveLoginResultUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/log-app-login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 약관 변경이력 조회
 * 약관 변경 이력을 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACE = <ThrowOnError extends boolean = false>(options: Options<TermHistoryUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TermHistoryUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/log-term/{term_category}',
        ...options
    });
};

/**
 * 중위소득 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmedianDASHincome = <ThrowOnError extends boolean = false>(options?: Options<GetEVoucherProviderListUsingGet2Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEVoucherProviderListUsingGet2Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/median-income',
        ...options
    });
};

/**
 * admin Token Refresh
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHadminSLASHrefreshUNDERSCOREtoken = <ThrowOnError extends boolean = false>(options: Options<AdminRefreshTokenUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AdminRefreshTokenUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member-oauth/admin/refresh_token',
        ...options
    });
};

/**
 * 웰로 before SNS 로그인
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHlogin = <ThrowOnError extends boolean = false>(options?: Options<WelloBeforeLoginUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<WelloBeforeLoginUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member-oauth/before/sns/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * kb 연동된 로그인 타입 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHkbDASHmemberDASHloginDASHtype = <ThrowOnError extends boolean = false>(options: Options<GetKbMemberLoginTypeListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKbMemberLoginTypeListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member-oauth/kb-member-login-type',
        ...options
    });
};

/**
 * 웰로 sns 로그인
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHlogin = <ThrowOnError extends boolean = false>(options?: Options<LoginWelloSnsMemberUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LoginWelloSnsMemberUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member-oauth/sns/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 Token Refresh
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHrefreshUNDERSCOREtoken = <ThrowOnError extends boolean = false>(options: Options<SnsRefreshTokenUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SnsRefreshTokenUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member-oauth/sns/refresh_token',
        ...options
    });
};

/**
 * Token 유효성 체크
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheck = <ThrowOnError extends boolean = false>(options?: Options<TokenStatusCheckUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<TokenStatusCheckUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member-oauth/token-status-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREsuccess = <ThrowOnError extends boolean = false>(options: Options<CheckPlusSuccessUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckPlusSuccessUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/nice-safe-key/check-plus_success',
        ...options
    });
};

/**
 * 신규 닉네임 조회
 * 신규 닉네임을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHwelloSLASHnickname = <ThrowOnError extends boolean = false>(options?: Options<NoticeListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<NoticeListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/member-wello/nickname',
        ...options
    });
};

/**
 * 웰로 멤버 메세지 수신거부
 */
export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHmessageDASHrejectSLASHmemberDASHwello = <ThrowOnError extends boolean = false>(options?: Options<RejectMessageUsingPut1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<RejectMessageUsingPut1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/message-reject/member-wello',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 메타코드 정보 조회
 * 메타코드 및 메타코드의 하위 코드까지 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcode = <ThrowOnError extends boolean = false>(options: Options<MetaCodeAllUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaCodeAllUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/meta-code',
        ...options
    });
};

/**
 * 공통코드 초기화
 * 공통코드가 추가된 경우 초기화 합니다
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHreset = <ThrowOnError extends boolean = false>(options: Options<CommonCodeInitUsingPost2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommonCodeInitUsingPost2Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/meta-code/reset',
        ...options
    });
};

/**
 * 관심 분야별 정책 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicy = <ThrowOnError extends boolean = false>(options: Options<AllowsInterestPolicyListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AllowsInterestPolicyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/interest-policy',
        ...options
    });
};

/**
 * 정책 검색목록 조회
 * 정책 검색목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicy = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyListUsingGet1Response, unknown, ThrowOnError>({
        querySerializer: {
            array: {
                explode: false,
                style: 'form'
            }
        },
        url: '/wello/v2/allows/policy',
        ...options
    });
};

/**
 * 누적 정책 & 정보 제공기관 수 조회
 * 누적 정책 & 정보 제공기관 수를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcount = <ThrowOnError extends boolean = false>(options?: Options<MetaPolicyCountUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MetaPolicyCountUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy-count',
        ...options
    });
};

/**
 * 비로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyFeedbackUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyFeedbackUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/feedback/{policy_id}',
        ...options
    });
};

/**
 * 신규정책 목록 조회
 * 신규정책 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatest = <ThrowOnError extends boolean = false>(options?: Options<LatestMetaPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LatestMetaPolicyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/latest',
        ...options
    });
};

/**
 * 홈화면 개편 신규정책 목록 조회
 * 홈화면 개편을 위한 신규정책 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestSLASHnew = <ThrowOnError extends boolean = false>(options?: Options<GetLatestPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLatestPolicyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/latest/new',
        ...options
    });
};

/**
 * 정책명으로 정책 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearch = <ThrowOnError extends boolean = false>(options: Options<GetPolicyListByPolicyNameUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPolicyListByPolicyNameUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/name-search',
        ...options
    });
};

/**
 * 가장 많이 본 정책 목록 조회
 * 가장 많이 본 정책 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHpopular = <ThrowOnError extends boolean = false>(options?: Options<PopularPolicyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PopularPolicyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/popular',
        ...options
    });
};

/**
 * 실시간 핫정책 TOP10 조회
 * 실시간 핫정책 TOP10을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHtop10 = <ThrowOnError extends boolean = false>(options?: Options<MetaPolicyTop10ListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MetaPolicyTop10ListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/top10',
        ...options
    });
};

/**
 * 비회원 정책 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACE = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/{meta_policy_id_idx}',
        ...options
    });
};

/**
 * 정책 AI 정보 업데이트
 */
export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHai = <ThrowOnError extends boolean = false>(options: Options<UpdatePolicyAiInfoUsingPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdatePolicyAiInfoUsingPutResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/{meta_policy_id_idx}/ai',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 관련 정책 목록 조회(최대 7개)
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated = <ThrowOnError extends boolean = false>(options: Options<GetRelatedMetaPolicyListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRelatedMetaPolicyListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/{meta_policy_id_idx}/related',
        ...options
    });
};

/**
 * 정책과 관련된 커뮤니티 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEpolicyUNDERSCOREidRBRACESLASHcommunity = <ThrowOnError extends boolean = false>(options: Options<GetPolicyRelatedCommunityListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPolicyRelatedCommunityListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy/{policy_id}/community',
        ...options
    });
};

/**
 * 공지사항 조회
 * 공지사항을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnotice = <ThrowOnError extends boolean = false>(options?: Options<NoticeListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<NoticeListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/cs/notice',
        ...options
    });
};

/**
 * 공지사항 조회
 * 공지사항을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeSLASHLBRACEnoticeUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<NoticeUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<NoticeUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/cs/notice/{notice_id}',
        ...options
    });
};

/**
 * 예산 포인트 정보 조회
 * 포인트 잔액, 출금 가능 포인트를 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHbudget = <ThrowOnError extends boolean = false>(options?: Options<GetPointBudgetUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPointBudgetUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/point/budget',
        ...options
    });
};

/**
 * 포인트 획득 조회
 * 유저 액션 별 획득 가능 포인트를 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHearning = <ThrowOnError extends boolean = false>(options?: Options<GetPointEarningUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPointEarningUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/point/earning',
        ...options
    });
};

/**
 * 타입별 포인트 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHinfo = <ThrowOnError extends boolean = false>(options: Options<GetPointInfoUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPointInfoUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/point/info',
        ...options
    });
};

/**
 * 내 상황에 맞는 정책 카테고리
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHcategory = <ThrowOnError extends boolean = false>(options?: Options<GetListPolicyCaseCategoryUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetListPolicyCaseCategoryUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy-case/category',
        ...options
    });
};

/**
 * 지역 좌표 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcodeDASHgeocoding = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyCodeGeocodingListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPolicyCodeGeocodingListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy-code-geocoding',
        ...options
    });
};

/**
 * 정책 사전 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHdictionary = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyDictionaryListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPolicyDictionaryListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy-dictionary',
        ...options
    });
};

/**
 * 랜덤티켓 - 럭키볼 당첨자 목록 조회(1000P, 10000P 당첨자)
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHrandomDASHticketSLASHluckyDASHballSLASHwinner = <ThrowOnError extends boolean = false>(options?: Options<GetRandomTicketWinnerListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRandomTicketWinnerListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/random-ticket/lucky-ball/winner',
        ...options
    });
};

/**
 * 파일 삭제
 */
export const deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3 = <ThrowOnError extends boolean = false>(options?: Options<FileDeleteUsingDelete1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<FileDeleteUsingDelete1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/s3',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 파일 업로드
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3 = <ThrowOnError extends boolean = false>(options?: Options<FileUploadUsingPost2Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<FileUploadUsingPost2Response, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/wello/v2/allows/s3',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3 = <ThrowOnError extends boolean = false>(options?: Options<UpdateFileTempSaveYnUsingPut1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateFileTempSaveYnUsingPut1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/s3',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 비회원 파일 복호화 다운로드
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3SLASHnonmemberDASHdecryption = <ThrowOnError extends boolean = false>(options: Options<FileDecryptionDownloadUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FileDecryptionDownloadUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/s3/nonmember-decryption',
        ...options
    });
};

/**
 * 정책 꾸러미 목록 조회
 * 정책 꾸러미 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituation = <ThrowOnError extends boolean = false>(options?: Options<SituationListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SituationListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/situation',
        ...options
    });
};

/**
 * 정책 꾸러미 정책 목록 조회
 * 정책 꾸러미 정책 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetSituationPolicyListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSituationPolicyListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/situation/{situation_id}',
        ...options
    });
};

/**
 * 약관 조회
 * 약관을 조회합니다.
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACE = <ThrowOnError extends boolean = false>(options: Options<TermUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TermUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/term/{term_category}',
        ...options
    });
};

/**
 * 웰컴 모니터 노출 대상 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelcomeDASHmonitor = <ThrowOnError extends boolean = false>(options: Options<GetWelcomeMonitorDisplayListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWelcomeMonitorDisplayListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/welcome-monitor',
        ...options
    });
};

/**
 * 웰로 앱 푸시 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpush = <ThrowOnError extends boolean = false>(options: Options<WelloAppPushListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<WelloAppPushListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-app-push',
        ...options
    });
};

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpush = <ThrowOnError extends boolean = false>(options?: Options<UpdateWelloAppPushReadUsingPut1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateWelloAppPushReadUsingPut1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-app-push',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 앱 푸시 알림 건수 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHcount = <ThrowOnError extends boolean = false>(options: Options<NewWelloAppPushCntUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<NewWelloAppPushCntUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-app-push/count',
        ...options
    });
};

/**
 * 웰로 앱 푸시(외부) 요청
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHext = <ThrowOnError extends boolean = false>(options?: Options<SendExtAppPushUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SendExtAppPushUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-app-push/ext',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 앱 푸시 트래킹&읽음 처리
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloAppPushReadUsingPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateWelloAppPushReadUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-app-push/{wello_app_push_receiver_id}',
        ...options
    });
};

/**
 * 댓글 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcomment = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentListUsingGet2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMetaPolicyCommentListUsingGet2Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-comment',
        ...options
    });
};

/**
 * 바우처 커뮤니티 댓글 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucher = <ThrowOnError extends boolean = false>(options: Options<GetCommunityVoucherCommentListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCommunityVoucherCommentListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-comment/community-voucher',
        ...options
    });
};

/**
 * @deprecated
 * 웰로 실시간 정책 의견
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHlive = <ThrowOnError extends boolean = false>(options?: Options<GetLiveWelloCommentListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLiveWelloCommentListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-comment/live',
        ...options
    });
};

/**
 * 댓글 상세 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACE = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMetaPolicyCommentListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-comment/{welloCommentId}',
        ...options
    });
};

/**
 * 웰로 디바이스 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfo = <ThrowOnError extends boolean = false>(options?: Options<SaveAllowsWelloDeviceInfoUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveAllowsWelloDeviceInfoUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-device-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 알림수신여부 조회
 * 알림수신 여부를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceive = <ThrowOnError extends boolean = false>(options: Options<MessageReceiveUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MessageReceiveUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-device-info/message-receive',
        ...options
    });
};

/**
 * 알림수신여부 수정
 * 알림수신 여부를 수정합니다
 */
export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceive = <ThrowOnError extends boolean = false>(options?: Options<UpdateMessageReceiveUsingPutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<UpdateMessageReceiveUsingPutResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-device-info/message-receive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 랜딩페이지 데이터 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHlanding = <ThrowOnError extends boolean = false>(options?: Options<DetailWelloLandingUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DetailWelloLandingUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-landing',
        ...options
    });
};

/**
 * 휴대전화번호 인증 발송
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphone = <ThrowOnError extends boolean = false>(options?: Options<SendCertificationCellphoneUsingPost1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SendCertificationCellphoneUsingPost1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/certification/cellphone',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 인증 번호 확인
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheck = <ThrowOnError extends boolean = false>(options?: Options<CertificationCheckUsingPost1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CertificationCheckUsingPost1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/certification/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 비회원 대상지역 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregion = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloNonmemberRegionUsingPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloNonmemberRegionUsingPostResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-nonmember-region',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 웰로 대상별 정책 - 대상 조회
 * 웰로 대상별 정책 - 대상 정보를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpick = <ThrowOnError extends boolean = false>(options?: Options<WelloPickListUsingGet1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WelloPickListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/pick',
        ...options
    });
};

/**
 * 웰로 대상별 정책 조회
 * 웰로 대상별 정책 정보를 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACE = <ThrowOnError extends boolean = false>(options: Options<WelloPickPolicyListUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<WelloPickPolicyListUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/contents/pick/{wello_pick_id}',
        ...options
    });
};

/**
 * 웰로픽! 요즘 뜨는 정책 목록 조회
 * 웰로픽 - 메인 정책 큐레이션 목록을 조회합니다
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpick = <ThrowOnError extends boolean = false>(options?: Options<GetWelloPickBannerListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWelloPickBannerListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/pick',
        ...options
    });
};

/**
 * 홈 - 정책 바로신청 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHapplySLASHhome = <ThrowOnError extends boolean = false>(options?: Options<GetHomeWelloPolicyApplyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetHomeWelloPolicyApplyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/policy-apply/home',
        ...options
    });
};

/**
 * 웰로 정책 코드 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcode = <ThrowOnError extends boolean = false>(options: Options<WelloPolicyCodeListUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<WelloPolicyCodeListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-policy-code',
        ...options
    });
};

/**
 * 웰로 정책 코드 전체 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHall = <ThrowOnError extends boolean = false>(options?: Options<WelloPolicyCodeAllListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WelloPolicyCodeAllListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-policy-code/all',
        ...options
    });
};

/**
 * 웰로 정책 코드 육아생활 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHbaby = <ThrowOnError extends boolean = false>(options?: Options<WelloPolicyCodeBabyListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WelloPolicyCodeBabyListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-policy-code/baby',
        ...options
    });
};

/**
 * IP로 현재 위치의 지역정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHgeolocation = <ThrowOnError extends boolean = false>(options: Options<GeolocationUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GeolocationUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-policy-code/geolocation',
        ...options
    });
};

/**
 * KB 정책 코드 목록
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHkb = <ThrowOnError extends boolean = false>(options?: Options<KbWelloPolicyCodeAllListUsingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<KbWelloPolicyCodeAllListUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-policy-code/kb',
        ...options
    });
};

/**
 * 경도&위도로 현재 위치의 지역정보 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHreverseDASHgeocoding = <ThrowOnError extends boolean = false>(options: Options<ReverseGeocodingUsingGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReverseGeocodingUsingGetResponse, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-policy-code/reverse-geocoding',
        ...options
    });
};

/**
 * 웰로 SEO 목록 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseo = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyWishlistUsingGet1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyWishlistUsingGet1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/seo',
        ...options
    });
};

/**
 * 웰로 SEO 총 개수 조회
 */
export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoSLASHcount = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyWishlistUsingGet2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MetaPolicyWishlistUsingGet2Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/seo/count',
        ...options
    });
};

/**
 * 웰로 비회원 트래킹 정보 저장
 */
export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrack = <ThrowOnError extends boolean = false>(options?: Options<SaveWelloTrackingUsingPost1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SaveWelloTrackingUsingPost1Response, unknown, ThrowOnError>({
        url: '/wello/v2/allows/wello-track',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};